import { Expose, Type } from 'class-transformer';
import { BasicData } from './BasicData';

export class BasicList {
    @Type(() => BasicData)
    data: BasicData[];

    @Expose()
    errorCode: number | null;

    @Expose()
    errors: string[];

    @Expose()
    total: number;
}
